import React from "react";
import { Modal } from "antd";
import styles from "assets/css/modals.module.css";
import { inject, observer } from "mobx-react";
import Cropper from "../Forms/MyCropper";

const ImageCropModal = props => {
  const { modalStore } = props;

  return (
    <>
      <Modal
        title={
          <div className="text-center">
            <h4 className="pt-3 fw-bold">Image Cropper</h4>
          </div>
        }
        closeIcon={
          <div className={`btn ${styles.modalCloseBtn}`}>
            <i className="fas fa-times"></i>
          </div>
        }
        visible={modalStore.showImageCropModal}
        onCancel={() => modalStore.toggleModal("showImageCropModal", false)}
        width={722}
        footer={null}
        centered
        zIndex={2000}
        maskStyle={{
          background: "linear-gradient(135deg, #00000080, #107c9885)"
        }}
      >
        <div className="px-5">
          <Cropper />
        </div>
      </Modal>
    </>
  );
};

export default inject(stores => ({
  modalStore: stores.store.modalStore
}))(observer(ImageCropModal));
